import React from 'react'

type Props = {
    children?: React.ReactNode;
    error?: boolean;
}

const HelperText = (props: Props) => {
    function getColorClassName() {
        if (props.error) {
            return "text-error"
        }
        return "text-primary-dark"
    }
    return (
        <div className={`${getColorClassName()} text-[13px] font-semibold mt-1`}>
            {props.children}
        </div>
    )
}

export default HelperText